var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Avatar, Button, List, Skeleton, Card, Spin } from 'antd';
import commonService from '../../services/CommonService';
import { formatDateDifference } from '../../utils/chartCalculations';
import { Link } from 'react-router-dom';
const RegulationUpdate = ({ flag }) => {
    const [loading, setLoading] = useState(false);
    const [regulationList, setRegulationList] = useState([]);
    const [fromCount, setFromCount] = useState(1);
    const [toCount, setToCount] = useState(10);
    const [requirementsList, setRequirementsList] = useState([]);
    useEffect(() => {
        if (flag == 1) {
            fetchRegulations();
        }
        if (flag == 2) {
            fetchRequirements();
        }
    }, []);
    const fetchRequirements = () => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        commonService.searchApprovalsBOMLazyLoadReact({ tblServiceRequest: JSON.stringify({ intFirstPage: fromCount, intPageSize: toCount }) })
            .then((result) => {
            setRequirementsList(result);
            setLoading(false);
        });
    });
    const fetchRegulations = () => {
        setLoading(true);
        commonService.getRegulationsListReact({ from: fromCount, to: toCount })
            .then((result) => {
            setRegulationList(result);
            setLoading(false);
        });
    };
    const onLoadMore = () => {
        setLoading(true);
        setToCount(toCount + 10);
        if (flag == 1) {
            commonService.getRegulationsListReact({ from: (toCount + 1), to: (toCount + 10) })
                .then((result) => {
                setRegulationList((prevList) => [...prevList, ...result]);
                setLoading(false);
            });
        }
        else {
            commonService.searchApprovalsBOMLazyLoadReact({ tblServiceRequest: JSON.stringify({ intFirstPage: (toCount + 1), intPageSize: (toCount + 10) }) })
                .then((result) => {
                setRequirementsList((prevList) => [...prevList, ...result]);
                setLoading(false);
            });
        }
    };
    const loadMore = !loading && regulationList.length % 10 === 0 ? (_jsx("div", { style: { textAlign: 'center', marginTop: 12, height: 32, lineHeight: '32px' }, children: _jsx(Button, { onClick: onLoadMore, children: "Load More" }) })) : null;
    return (_jsxs(Card, { title: flag === 1 ? "Regulation Updates" : "Latest Requirements", className: 'dashboard-card', size: 'small', children: [flag === 1 && (_jsx(Spin, { spinning: loading, children: _jsx(List, { size: 'small', 
                    // loading={loading}
                    itemLayout: "horizontal", loadMore: loadMore, dataSource: regulationList, renderItem: (item) => {
                        var _a;
                        return (_jsx(List.Item, { children: _jsxs(Skeleton, { avatar: true, title: false, loading: loading, active: true, children: [_jsx(List.Item.Meta, { avatar: _jsx(Avatar, { src: `https://flagsapi.com/${getCountryCode((_a = item.objLuCountry) === null || _a === void 0 ? void 0 : _a.strShortDesc)}/flat/64.png` }), title: _jsx(Link, { to: `/regulatory-library-details/${item.strRegLibId ? btoa(item.strRegLibId) : null}`, target: "_blank", children: item.strTitle }), description: item === null || item === void 0 ? void 0 : item.strSourceAgency }), _jsx("div", { children: formatDateDifference(item.dtLastUpdatedDate) })] }) }, item.strTitle));
                    }, style: { height: '500px', overflowY: 'auto' } }) })), flag === 2 && (_jsx(Spin, { spinning: loading, children: _jsx(List, { size: 'small', 
                    // loading={loading}
                    itemLayout: "horizontal", loadMore: loadMore, dataSource: requirementsList, renderItem: (item) => {
                        var _a, _b;
                        return (_jsx(List.Item, { children: _jsxs(Skeleton, { avatar: true, title: false, loading: loading, active: true, children: [_jsx(List.Item.Meta, { avatar: _jsx(Avatar, { src: `https://flagsapi.com/${getCountryCode((_a = item.objLuCountry) === null || _a === void 0 ? void 0 : _a.strShortDesc)}/flat/64.png` }), title: _jsxs(Link, { to: `/regulation-information/details/${item.strRegulationId ? btoa(item.strRegulationId + '-' + item.intRegVersion) : null}`, target: "_blank", rel: "noopener noreferrer", children: [(_b = item.objLuServiceCode) === null || _b === void 0 ? void 0 : _b.strLongDesc, " / ", item.objLuCountry.strLongDesc] }), description: `${item.objLuProductMainType.strLongDesc} / 
                    ${item.objLuProductType.strLongDesc} / ${item.objLuCertificationType.strLongDesc}` }), _jsx("div", { children: formatDateDifference(item.dtLastUpdatedDate) })] }) }, item.objLuCountry.strLongDesc));
                    }, style: { height: '500px', overflowY: 'auto' } }) }))] }));
};
export default RegulationUpdate;
function getCountryCode(countryShortDesc) {
    switch (countryShortDesc) {
        case 'AE1':
            return 'AE';
        case 'CE':
            return 'EC';
        case 'CIS':
            return 'RU';
        default:
            return countryShortDesc;
    }
}
